// Package imports:
import React, { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
// Component imports:
import VedbondForm from './VedbondForm';
import Link from '../../../ui-elements/Link/Link';
//Type imports:
import { MySettingsViewModel } from "../../../types/MyKeldaTypes";

interface IProps {
    model?: MySettingsViewModel
}
const Vedbond: React.FC<IProps> = ({
    model,
}) => {
    const [ contactResponse, setContactResponse ] = useState(<></>);
    return (
        <div className="Vedbond">
            <div className="row">
                {(contactResponse) && (
                    <div className="form__row">
                        <div className="form__col">
                            {contactResponse}
                        </div>
                    </div>
                )}
            </div>
            <div className="section__body">
                <h3>Veðbönd</h3>
                <p>Þegar óskað er eftir aðgangi að þinglýsingarbókum (veðböndum) þarf að gefa skýringu á hvers vegna og staðfesta að aðgangur sé nauðsynlegur vegna starfsemi sinnar.</p>
                <p>Keldan áskilur sér þann rétt að sannreyna þær skýringar sem gefnar eru upp og veita öðrum upplýsingar um þær eftir því sem lög og reglur mæla fyrir um.</p>
                <Link url="/Skilmalar" linkSize="16">
                    <FontAwesomeIcon icon={faAngleRight} />
                    {"Nánar um veðbönd í skilmálum Keldunnar"}
                </Link>
                <VedbondForm setContactResponse={setContactResponse} model={model} />
            </div>
        </div>
    )
}

export default Vedbond;